module.exports = __webpack_public_path__ + "static/media/map-marker-question.a8eed149.svg";